import LogRocketTracker from "@features/tracking/components/LogrocketTracking"

export const InnerAppTracking = () => {
  return (
    <>
      <LogRocketTracker />
    </>
  )
}
